import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useLocation } from "react-router-dom";

import { KamsUrlFiltersEnum, KamsUrlQueryParams } from "./url";
import HomePage from "./views";

const HomePageView: React.FC = () => {
  const location = useLocation();
  const qs = parseQs(location.search.substr(1));
  const params = asSortParams(qs, KamsUrlFiltersEnum) as KamsUrlQueryParams;
  return <HomePage params={params} />;
};

// const Component = () => <HomePageView />;

export default HomePageView;
